import { useMarketAccountsContext, type MultilegMarketDetails, type UnifiedLiquidityResponse } from '@talos/kyoko';
import { useMemo } from 'react';

export function useUnifiedLiquidityMarketDetails(
  unifiedLiquidityToken: UnifiedLiquidityResponse | undefined
): MultilegMarketDetails[] | undefined {
  const { marketAccountsList } = useMarketAccountsContext();
  return useMemo(() => {
    if (!unifiedLiquidityToken) {
      return undefined;
    }

    const availableMarkets = unifiedLiquidityToken?.Tokens.map(m => m.Market) || [];

    const availableMarketsSet = new Set(availableMarkets);
    const availableMarketAccounts =
      marketAccountsList
        ?.filter(ma => availableMarketsSet.has(ma.Market))
        .map(ma => ({ MarketAccount: ma.Name, Market: ma.Market })) || [];

    return availableMarketAccounts;
  }, [unifiedLiquidityToken, marketAccountsList]);
}
